import React from 'react'
import { useTrans } from '@next-nx/hooks'
import { Check } from '@next-nx/shared-ui/icons'
import styles from './NoleggioStepCanoneAnimation.module.sass'

interface Props {
  className?: string
}

const NoleggioStepCanoneAnimation = (props: Props) => {
  const { className = '' } = props

  const t = useTrans()

  const itemList = [
    t('Servizi inclusi'),
    t('Assicurazioni'),
    t('Pneumatici'),
    t('Riparazione sinistri'),
    t('Soccorso stradale'),
  ]

  return (
    <div className={`${styles.root} ${className}`}>
      <div className={styles.content}>
        <div className={styles.title}>{t('Canone mensile fisso')}</div>
        {/* <div className={styles.value}>
          {t("260 €")}
        </div> */}
      </div>
      <div className={styles.list}>
        {itemList.map((x, index) => (
          <div className={styles.item} key={index}>
            <span className={styles.itemIcon}>
              <Check />
            </span>
            <span className={styles.itemLabel}>{x}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default NoleggioStepCanoneAnimation
